export interface IPatientIntakeListItem {
    medicalRecordId: number,
    patientScreenId: number,
    patientScreenChoiceId: number,
    
    centerId: number,
    centerName: string,

    source: string,
    firstName: string,
    lastName: string,
    preferredName: string,
    email: string,
    dateOfBirth: string,
    gender: string,
    
    registrationDate: string,
    registrationStatusId: number,
    registrationStatus: string,
    referralStatusId: number,
    referralStatus: string,

    followUpDate: string,
    coordinatorId: number,
    coordinatorName: string,

    selectedGoal: number,
    stateProvince: string,
    addressIsUs: boolean,

    hasPendingPreWorkupLabs: boolean,
    hasAboResults: boolean,

    recipientId: number,
    recipientAlias: string,
    recipientCenterId: number,
    recipientCenter: string,
    recipientSameCenter: boolean,
    recipientTransplantDate: string,

    micrositeRecipientId: number,
    micrositeRecipientCenterId: number,
    micrositeRecipientCenter: string,
    micrositeSameCenter: boolean,

    transferRequest: boolean
}